import styled from 'styled-components'
import {
  Modal as BuiModal,
  TextHeadline1,
  IconClose,
  TextArea as BuiTextArea,
  Button as BuiButton,
  TextCaption2,
  colors,
} from '@blocket/blocket-ui'
import { mediaQueries } from 'plugins/device'

export const Modal = styled(BuiModal)`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  width: 90%;
  left: 50%;
  top: 50%;
  height: auto;
  transform: translate(-50%, -50%);
  @media ${mediaQueries.medium} {
    width: 750px;
    padding: 32px;
  }
`

export const Headline = styled(TextHeadline1)`
  font-size: 17px;
  margin-bottom: 16px;
  text-align: center;
  font-family: 'BlocketSans-Medium';
  @media ${mediaQueries.medium} {
    font-size: 28px;
    margin-bottom: 24px;
    text-align: left;
    font-family: 'BlocketSans-Bold';
  }
`

export const CloseIcon = styled(IconClose)`
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${mediaQueries.medium} {
    flex-direction: row;
    align-items: flex-start;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  @media ${mediaQueries.medium} {
    margin-left: 65px;
    width: 526px;
  }
`

export const NameColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${mediaQueries.medium} {
    align-items: flex-start;
  }
`

export const EditButton = styled(BuiButton)`
  width: 170px;
  margin: 16px auto;
  font-size: 12px;
  svg {
    margin-right: 6px;
  }
  @media ${mediaQueries.medium} {
    margin: 0px 0px 16px 0px;
  }
`

export const TextArea = styled(BuiTextArea)`
  margin-top: 16px;
  background-color: transparent; // makes the error ! mark look good.
  label {
    font-size: 15px;
    font-family: 'BlocketSans-Regular';
    @media ${mediaQueries.medium} {
      font-size: 17px;
      font-family: 'BlocketSans-Medium';
    }
  }
`

export const TextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
`

export const GuidText = styled(TextCaption2)`
  color: ${colors.grey500};
`

export const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 24px;
`

export const Button = styled(BuiButton)`
  flex-grow: 1;
  &:first-child {
    margin-right: 16px;
  }
  @media ${mediaQueries.medium} {
    width: 130px;
    flex-grow: 0;
  }
`
